import { Organization } from '../../domain/entities/Organization';
import { OrganizationRepository } from '../../domain/repositories/OrganizationRepository';

export class GetOrganizationInfoUseCase {
  constructor(private organizationRepository: OrganizationRepository) {}

  async execute(): Promise<Organization> {
    return await this.organizationRepository.getOrganization();
  }
} 